<template>
  <div>
    <el-card shadow="never">
      <el-table :data="tableData">
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="userName" label="姓名" width="200">
          <template slot-scope="scope">
            {{ `${scope.row.userName}（${scope.row.userId}）` }}
          </template>
        </el-table-column>
        <el-table-column prop="learnedCourseCount" label="已学习视频数量" />
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="scope">
            <el-button type="text" size="small" @click="lookItem(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="search.current" :page-size="search.size" layout="total, sizes, prev, pager, next"
        :total="totalNum" background />
    </el-card>

    <!-- 新增品牌 -->
    <el-drawer :title="`【${form.userName}】的学习记录`" :visible.sync="drawerVisible" size="50%">
      <div style="padding: 0 10px;">
        <el-table :data="lookHistory" border stripe>
          <el-table-column label="序号" width="80" type="index" />
          <el-table-column label="课程名称" prop="courseName" />
          <el-table-column label="视频名称" prop="chapterName" />
          <el-table-column label="学习完成时间" prop="completedTime" />
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>


<script>
import uploadCover from '@/components/upload-cover/upload-cover.vue'
export default {
  components: {
    uploadCover
  },
  watch: {
    drawerVisible(val) {
      if (!val) {
        this.form = {}
      }
    }
  },
  data() {
    return {
      drawerVisible: false,
      totalNum: 0,
      tableData: [],
      search: {
        current: 1,
        size: 20
      },
      form: {},
      lookHistory: [],
      lookHistoryLoading: false,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await this.$request.post("/cms/user_course/get_user_list", this.search)
      if (res.data.code == 200) {
        this.tableData = res.data.data.records
        this.totalNum = res.data.data.total
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.search.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.search.current = val
      this.getList()
    },
    async deleteItem(id) {
      const res = await this.$request.get("/cms/pack_customization/delete_pack_template?packId=" + id)
      if (res.data.code == 200) {
        this.$message.success("删除成功")
        this.getList()
      }
    },
    lookItem(row) {
      this.form = this.$deepClone(row)
      this.getUserLookHistory()
      this.drawerVisible = true
    },
    async getUserLookHistory() {
      this.lookHistoryLoading = true
      const res = await this.$request.get("/cms/user_course/get_user_list_by_id?userId=" + this.form.userId)
      if (res.data.code == 200) {
        this.lookHistory = res.data.data
      }
      this.lookHistoryLoading = false
    },
  }
}
</script>